import {
  SET_NOTIFICATIONS,
  UNSET_NOTIFICATIONS,
} from '../actions/notifications-actions';

export default (
  state = [],
  action,
) => {
  const newState = state.slice();

  switch (action.type) {
    case SET_NOTIFICATIONS:
      return action.notifications.slice();

    case UNSET_NOTIFICATIONS:
      return [];

    default:
      return newState;
  }
};



// WEBPACK FOOTER //
// ./main/reducers/notifications-reducer.js